<div class="row">
    <div class="col-auto">
        <div class="input-group input-group-sm">
            <input type="text" class="form-control" placeholder="검색어"
                [(ngModel)]="searchValue"
                (keyup.enter)="keyupEnterSearchValue($event)">
            <div class="input-group-append">
                <button type="button" class="btn btn-outline-secondary"
                    (click)="clickSearch()">
                    <i class="fas fa-search"></i>
                    <span class="ml-1">
                        검색
                    </span>
                </button>
            </div>
        </div>
    </div>
    <div class="col"></div>
    <div class="col-auto"
        [hidden]="listType === DtgListType.modal">
        <button type="button" class="btn btn-sm btn-outline-secondary"
            (click)="clickOpenModalTeamInfo(DtgActionType.create,null)">
            <i class="mdi mdi-plus"></i>
            <span class="ml-1">
                그룹추가
            </span>
        </button>
    </div>
    <div class="col-auto">
        <button type="button" class="btn btn-sm btn-outline-success"
            (click)="exportExcel()">
            <i class="fas fa-file-excel"></i>
            <span class="ml-1">엑셀출력</span>
        </button>
    </div>
</div>

<div class="table-responsive mt-3">
    <table class="table table-sm table-hover align-items-center mb-0">
        <thead class="">
            <th>
                그룹이름
            </th>
            <th>
                위도
            </th>
            <th>
                경도
            </th>
            <th>
                주소
            </th>
            <th>
                사용여부
            </th>
            <th [hidden]="listType === DtgListType.modal">
                편집
            </th>
        </thead>
        <tbody class="">
            <tr *ngFor="let item of listTeam;">
                <td>
                    <span [hidden]="listType === DtgListType.modal">{{item.dtgTeamNm}}</span>
                    <button type="button" class="btn btn-sm btn-link px-0"
                        [hidden]="listType === DtgListType.list"
                        (click)="clickSelectTeam(item)">
                        <span class="">{{item.dtgTeamNm}}</span>
                    </button>
                </td>
                <td>
                    <span [hidden]="!item.lat || item.lat === '0.0000000000'">{{item.lat}}</span>
                    <span [hidden]="item.lat && item.lat !== '0.0000000000'" class="text-warning">
                        미설정
                    </span>
                </td>
                <td>
                    <span [hidden]="!item.lng || item.lng === '0.0000000000'">{{item.lng}}</span>
                    <span [hidden]="item.lng && item.lat !== '0.0000000000'" class="text-warning">
                        미설정
                    </span>
                </td>
                <td>
                    <span [hidden]="!item.addr1">{{item.addr1}}</span>
                    <span [hidden]="item.addr1" class="text-warning">
                        미설정
                    </span>
                </td>
                <td>
                    {{item.useYn}}
                </td>
                <td [hidden]="listType === DtgListType.modal">
                    <button type="button" class="btn btn-sm btn-outline-secondary"
                        (click)="clickOpenModalTeamInfo(DtgActionType.update,item)">
                        <i class="mdi mdi-pen"></i>
                        <span class="ml-1">수정</span>
                    </button>
                </td>
            </tr>
        </tbody>
    </table>
</div>

<div class="mt-3">
    <list-paging
        [inputPagingInfo]="pagingInfo"
        (callbackClickPageNumber)="callbackClickPageNumber($event)"
        (callbackChangeCountRowPerPage)="callbackChangeCountRowPerPage($event)"></list-paging>
</div>